import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget } from '@eforall/dashboard';
import { DomainDataService } from '../../../../../services';
import { ReadonlyAccessWidget } from '../../../readonly-access/readonly-access.widget';
import { EntrepreneurProspectDialogDataService } from '../entrepreneur-prospect-dialog-data.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'entrepreneur-prospect-dialog-courses-part',
	standalone: true,
	imports: [GridContentWidget, ReadonlyAccessWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './courses.part.html',
})
export class EntrepreneurProspectDialogCoursesPart {

	public dialogBodyHeight = input.required<number>();

	private readonly util = inject(UtilityService);
	private readonly domainData = inject(DomainDataService);
	public readonly dialogDataService = inject(EntrepreneurProspectDialogDataService);

	public setup = getSetup(this.util, this.domainData);

	// subtracting 70 to account for padding and tabstrip, and 45 for readonly access widget if applicable
	public customHeight = computed(() => this.dialogBodyHeight() - 70 - (this.dialogDataService.isReadonly() ? 45 : 0));

	public courses = computed(() => this.dialogDataService.dialogData()?.courses ?? []);

}